import { createApp } from '@app/adapters/create-app'
import AIReviewAcceptButton from '@app/application/reconciliation_proposal/components/ai-review-accept-button.vue'

export default (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const element = doc.querySelector(
      '[data-behaviour="ai-proposal-accept-button"]'
    ) as HTMLElement

    if (element) {
      const { acceptUrl, acceptLabel, proposalsBlocked, workflowId } =
        element.dataset ?? {}

      createApp(AIReviewAcceptButton, {
        text: acceptLabel,
        url: acceptUrl,
        proposalsBlocked: proposalsBlocked === 'true',
        workflowId: typeof workflowId !== 'undefined' ? workflowId : '',
      }).mount(element)
    }
  })
}
